<template>
  <div class="u-grid__item [ u-2/3@wide ]">
    <div class="c-live-panel" :class="votingEnabled">
      <div class="c-live-panel__main" :style="styleObject" :class="classObject">
        <Vote />
        <div class="c-live-panel__content">
          <h1 v-if="!isMgp" class="o-heading__program-title c-live-panel__title"><em v-if="program.shout">{{program.shout}}</em> {{program.title}}</h1>
          <p v-if="!isMgp" class="c-live-panel__timings">{{program.schedule}}</p>
          <div class="c-live-panel__actions">
            <a v-if="channel && channel.hasVideo" @click.prevent="openVideo(channel.id)" href="#" class="c-button c-button--base c-live-panel__button">Kijk live</a>
            <a @click.prevent="openChannel(channel.id)" href="#" class="c-button c-button--base c-live-panel__button" data-action="open-radioplayer" data-position="hero">Luister live</a>
          </div>
          <HitlistTrack class="c-live-panel__hitlist" :title="lastPlay.title" :artist="lastPlay.artist.name" :thumbnail="lastPlay.thumbnail" :position="hitlistPosition" v-if="isHitlist">
            <a class="c-button c-button--base c-live-panel__button" :href="hitlistUrl">Volg de lijst</a>
          </HitlistTrack>
          <div v-if="lastPlay && !isMgp && !isHitlist" class="c-live-panel__onair">
            <div class="c-live-panel__onair-key">
              <SvgIcon icon="audio" class="o-icon--audio" />
              Nu op de radio:
            </div>
            <div class="c-live-panel__onair-value">
              {{lastPlay.artist.name}} - {{lastPlay.title}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { openPlayer } from '../../mixins/radioPlayer';
import Vote from '../vote/Vote';
import HitlistTrack from '../hitlist/Track'

import {cdnUrl} from '../../filters/imageFilters'

export default {
  name: 'LiveProgram',
  mixins: [openPlayer],
  components: {
    Vote,
    HitlistTrack
  },
  computed: {
    styleObject() {
      return (this.program && this.program.homepageImage) ? {
        backgroundImage : `url(${cdnUrl(this.program.homepageImage) })`,
      } : {};
    },
    classObject() {
      return {
        'c-live-panel__placeholder': !(this.program && this.program.homepageImage),
      };
    },
    isMgp() {
      return this.mgp.running;
    },
    isHitlist() {
      return this.lastPlay && this.lastPlay.active_editions.length
    },
    hitlistPosition() {
      if (!this.isHitlist) { return }

      const {position} = this.lastPlay.active_editions[0]
      return position
    },
    hitlistUrl() {
      if (!this.isHitlist) { return }

      const {edition: {id: editionId}} = this.lastPlay.active_editions[0]

      return `/editions/redirect/${editionId}`
    },
    votingEnabled() {
      return {
        'c-live-panel--vote': this.mgp.running
      }
    },
    lastPlay() {
      return this.channel && this.channel.lastPlay
    },
    ...mapState({
      program: state => state.program.program,
      mgp: state => state.mgp,
    }),
    ...mapGetters({
      channel: 'channels/mainChannel'
    })
  },
};
</script>
